if (!customElements.get('adev-product-cta')) {
    customElements.define('adev-product-cta', class adevProductCta extends HTMLElement {
        constructor() {
            super();
        }

        initCarousel() {
            this.carouselEl = this.querySelector('[data-adev-product-cta="swatches-carousel"]');
            if (!this.carouselEl) return;

            let settings = {
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: 0,
                adaptiveHeight: false,
                selectedAttraction: 0.01,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.updateArrows();
                        this.refreshTooltips();
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.updateArrows();
                        this.refreshTooltips();
                    },
                    change: () => {
                        this.updateArrows();
                        this.refreshTooltips();
                    },
                    select: () => {
                        this.updateArrows();
                        this.refreshTooltips();
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            this.initArrows();

            this.updateArrows();
        }

        destroyCarousel() {
            if (this.carouselInstance) {
                this.carouselInstance.destroy();
                this.carouselInstance = null;
            }
        }

        initArrows() {
            const prevButton = this.querySelector('[data-adev-product-cta="swatches-prev"]');
            const nextButton = this.querySelector('[data-adev-product-cta="swatches-next"]');

            if (!prevButton || !nextButton) return;

            prevButton.addEventListener('click', () => {
                if (this.carouselInstance) {
                    this.carouselInstance.previous();
                }
            });

            nextButton.addEventListener('click', () => {
                if (this.carouselInstance) {
                    this.carouselInstance.next();
                }
            });
        }

        updateArrows() {
            if (!this.carouselInstance) return;

            console.log(this.carouselInstance);
        
            const parent = this.carouselEl.closest('[data-adev-product-cta="swatches-wrap"]');
            const visibleCells = this.carouselInstance.options.groupCells || 1;
            const totalCells = this.carouselInstance.cells.length;
            const selectedIndex = this.carouselInstance.selectedIndex;
        
            if (totalCells > visibleCells && selectedIndex > 0) {
                parent.classList.add('has--prev');
            } else {
                parent.classList.remove('has--prev');
            }
        
            if (totalCells > visibleCells && selectedIndex < totalCells - visibleCells) {
                parent.classList.add('has--next');
            } else {
                parent.classList.remove('has--next');
            }

            const currentlyViewedWidth = this.carouselInstance.size.innerWidth;
            const slideableWidth = this.carouselInstance.slideableWidth;
            const x = this.carouselInstance.selectedSlide.x;

            if (currentlyViewedWidth >= slideableWidth) {
                parent.classList.remove('has--prev', 'has--next');
                return;
            }

            if (x > 0) {
                parent.classList.add('has--prev');
            } else {
                parent.classList.remove('has--prev');
            }

            if (Math.abs(x) + currentlyViewedWidth < slideableWidth) {
                parent.classList.add('has--next');
            } else {
                parent.classList.remove('has--next');
            }


        }

        refreshTooltips() {
            this.querySelectorAll('[data-adev-product-cta="swatch-title"]').forEach(tooltip => {
                tooltip.style.transform = 'translateY(10px)';
                tooltip._popperInstance.update();
            });
        }

        initTooltips() {
            this.querySelectorAll('[data-adev-product-cta="swatch"]').forEach(button => {
                const id = button.getAttribute('data-id');
                const tooltip = this.querySelector(`[data-adev-product-cta="swatch-title"][data-id="${id}"]`);

                const showEvents = ['mouseenter', 'focus'];
                const hideEvents = ['mouseleave', 'blur'];

                showEvents.forEach(event => {
                    button.addEventListener(event, () => {
                        tooltip.style.opacity = '1';
                        tooltip.style.visibility = 'visible';
                    });
                });

                hideEvents.forEach(event => {
                    button.addEventListener(event, () => {
                        tooltip.style.opacity = '0';
                        tooltip.style.visibility = 'hidden';
                    });
                });

                tooltip._popperInstance = Popper.createPopper(button, tooltip, {
                    placement: 'top',
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 10],
                            },
                        },
                    ],
                });

            });
        }

        connectedCallback() {
            this.initTooltips();
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
        }

    });
}